import { render, staticRenderFns } from "./EntityTabs.vue?vue&type=template&id=69e3a93c&scoped=true&"
import script from "./EntityTabs.vue?vue&type=script&lang=js&"
export * from "./EntityTabs.vue?vue&type=script&lang=js&"
import style0 from "./EntityTabs.vue?vue&type=style&index=0&id=69e3a93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e3a93c",
  null
  
)

export default component.exports